import { render, staticRenderFns } from "./CardKultour.vue?vue&type=template&id=ef3bf028&scoped=true"
import script from "./CardKultour.vue?vue&type=script&lang=js"
export * from "./CardKultour.vue?vue&type=script&lang=js"
import style0 from "./CardKultour.vue?vue&type=style&index=0&id=ef3bf028&prod&lang=scss&scoped=true"
import style1 from "./CardKultour.vue?vue&type=style&index=1&id=ef3bf028&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef3bf028",
  null
  
)

export default component.exports